import axios from "axios";
import { useContext, useState, useEffect } from "react";
import { createContext } from "react";
import { security_key, Url } from "../../Services/Api"; // If you have a centralized API URL

const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {


  const [orderInsights, setOrderInsights] = useState({
    newOrders: 0,
    completedOrders: 0,
    processingOrders: 0,
    cancelledOrders: 0,
    totalSale: 0,
    netSale: 0,
    averageSale: 0
  });

  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(true);
  const [recentOrders, setRecentOrders] = useState([]);


  const [performanceInsights, setPerformanceInsights] = useState({
    count: 0,
    averageScore: 0,
    averageFCP: 0,
    averageLCP: 0,
    averageTBT: 0,
    averageCLS: 0,
    averageSI: 0
  });

  const [performanceHistory, setPerformanceHistory] = useState([]);

  const [adverstisementData, setAdvData] = useState(
    {
      monthlySale: null,
      performance: null,
      monthlyOrders: null,
      productName: ""
    }
  )



  const [error, setError] = useState(null);

  const [topProducts, setTopProducts] = useState([]);
  const [topCategories, setTopCategories] = useState([]);

  const sale_chart_filters = [
    {
      name: "1M",
      value: "last_1_month"
    },
    {
      name: "7D",
      value: "last_7_days"
    },
    {
      name: "1D",
      value: "last_1_day"
    },
    {
      name: "1H",
      value: "last_7_hours"
    },
  ];
  const [saleChartFilter, setSaleChartFilter] = useState("last_1_month");
  const [saleChart, setSaleChart] = useState([]);
  const [saleChartCumm, setSaleChartCumm] = useState({
    totalSale: 0,
    netSale: 0
  });

  const setSelectedFilterSale = (value) => {
    setSaleChartFilter(value);
    fetchSalesData();
  }


  const fetchInsights = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };
      const response = await axios.get(`${Url}/api/v1/orders/insights/get`, { headers: headers });
      setRecentOrders(response?.data?.orders);
      setOrderInsights({
        newOrders: response?.data?.newOrders,
        completedOrders: response?.data?.statusCounts?.completed,
        processingOrders: response?.data?.statusCounts?.processing, // Updated here as well
        cancelledOrders: response?.data?.statusCounts?.cancelled,
        totalSale: response?.data?.totalSales,
        netSale: response?.data?.netSale,
        averageSale: response?.data?.averageSale
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchPerformanceInsights = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };


      const response = await axios.get(`${Url}/api/v1/performance/web-performance/get`,{headers:headers});
      setPerformanceHistory(response?.data?.data
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))  // Sort by createdAt (ascending)
        .slice(0, 5)  // Take the first five records
      );

      setPerformanceInsights({
        count: response?.data?.summary?.desktop?.count,
        averageScore: response?.data?.summary?.desktop?.averageScore,
        averageFCP: response?.data?.summary?.desktop?.averageFCP,
        averageLCP: response?.data?.summary?.desktop?.averageLCP,
        averageTBT: response?.data?.summary?.desktop?.averageTBT,
        averageCLS: response?.data?.summary?.desktop?.averageCLS,
        averageSI: response?.data?.summary?.desktop?.averageSI
      });
      setAdvData(prevState => ({
        ...prevState,
        performance: response?.data?.summary?.desktop?.averageScore
      }));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading2(false);
    }
  };

  const fetchTopProCat = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };

      const response = await axios.get(`${Url}/api/v1/orders/insights/get-top-cat-pro?month=3`, { headers: headers });
      setTopProducts(response?.data?.topProducts);
      setTopCategories(response?.data?.topCategories);

      response?.data?.topProducts.length > 0 &&
        setAdvData(prevState => ({
          ...prevState,
          productName: response?.data?.topProducts[0]?.productName,
          monthlyOrders: response?.data?.totalOrders
        }))

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading2(false);
    }
  };



  const fetchSalesData = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };
      const response = await axios.get(`${Url}/api/v1/orders/insights/get-sale-chart?filter=${saleChartFilter}`, { headers: headers });
      setSaleChart(response?.data?.graphData);
      setSaleChartCumm({
        totalSale: response?.data?.totalSalesSum,
        netSale: response?.data?.netSalesSum
      });
      setAdvData(prevState => ({
        ...prevState,
        monthlySale: response?.data?.totalSalesSum
      }));
      console.log(`here is data according to ${saleChartFilter}:`, response?.data?.graphData);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  // Fetch data when the component mounts
  useEffect(() => {
    fetchInsights();
    fetchPerformanceInsights();
    fetchTopProCat();
    fetchSalesData();
  }, []);

  useEffect(() => {
    fetchSalesData();
  }, [saleChartFilter]);

  const getGreetMessage = (id) => {
    if (id === 2) {
      return `Great to see you! Your store made $${adverstisementData.monthlySale} sales yesterday. Let's aim even higher today!`
    } else if (id === 4) {
      return
    }
  }



  const greetings = [
    {
      id: 1,
      message: `"Success is not the key to happiness. Happiness is the key to success. If you love what you are doing, you will be successful."`
    },
    {
      id: 2,
      message: "Great to see you! Your store made [x] sales yesterday. Let's aim even higher today!"
    },
    {
      id: 3,
      message: "Your store is running smoother than butter on toast. Let’s make today amazing!"
    },
    {
      id: 4,
      message: "Did you know? It’s been [X] days since your store performance is above [x%] empowering shoppers. Keep up the fantastic work!"
    },
    {
      id: 5,
      message: "Let’s make this Season unforgettable for your customers."
    },
    {
      id: 6,
      message: "Your customers left [X] new reviews this week. Check them out!"
    },
    {
      id: 7,
      message: "Yesterday, your most viewed product was [Product Name]. Don’t forget to advertise more!"
    }
  ];



  return (
    <DashboardContext.Provider
      value={{
        orderInsights,  // Use orderInsights here
        loading,
        error,
        recentOrders,
        fetchInsights,
        fetchPerformanceInsights,
        performanceHistory,
        performanceInsights,
        loading2,
        topProducts,
        topCategories,
        saleChart,
        saleChartCumm,
        sale_chart_filters,
        saleChartFilter,
        setSaleChartFilter,
        setSelectedFilterSale,
        adverstisementData
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

// Custom hook to access the dashboard data context
export const useDashboardData = () => {
  return useContext(DashboardContext);
};
